export const researchPopup = () => {
    var exitButtons = document.querySelectorAll('.popup__research--exit, .popup__research--rgba');
    var researchListing = document.querySelectorAll('.open-research-popup');

    exitButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            var popupResearch = document.querySelector('.popup__research');
            popupResearch.classList.remove('open');
        });
    });
    researchListing.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            var id = e.target.closest('.jet-listing-grid__item').getAttribute('data-post-id');
            var ajaxurl = '/wp-admin/admin-ajax.php';

            var xhr = new XMLHttpRequest();
            xhr.open('POST', ajaxurl, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var result = xhr.responseText;
                    var researchDetails = document.querySelector('.popup__research--details');
                    researchDetails.innerHTML = result;
                    var popupResearch = document.querySelector('.popup__research');
                    popupResearch.classList.add('open');
                }
            };
            xhr.send('id_post=' + id + '&action=get_research');
        });
    });
}
